import { useEffect, useState } from "react"
import {
  ChevronRight
} from "lucide-react"

import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "../ui/carousel"
import { TestimonialCard } from "../testimonial-card"
import { Link } from "react-router-dom"
import { Button } from "../ui/button"
import { Badge } from "../ui/badge"

export default function TestimonialsWidget() {
  const [testimonials, setTestimonials] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function loadTestimonials() {
      try {
        const res = await fetch(
          "/wp-json/wp/v2/testimonials?per_page=10"
        )
        const data = await res.json()
        setTestimonials(data)
        setLoading(false)
      } catch (e) {
        console.error("Error loading testimonials:", e)
        setLoading(false)
      }
    }

    loadTestimonials()
  }, [])

  if (loading) {
    return <p className="text-center py-10">Loading testimonials...</p>
  }

  return (
    <section className="py-12 bg-white">
      <div className="container px-4 mx-auto">
        <div className="flex flex-col items-center mb-10 text-center">
          <Badge className="mb-2">Testimonials</Badge>
          <h2 className="mb-4 text-3xl font-bold md:text-4xl">What Our Patients Say</h2>
          <p className="max-w-2xl text-[#485260]">
            Read about the experiences of patients who have received care at Pranaam Hospitals.
          </p>
        </div>

        <Carousel className="w-full max-w-5xl mx-auto">
          <CarouselContent>
            {testimonials.map((item, idx) => (
              <CarouselItem key={idx} className="md:basis-1/2 lg:basis-1/3">
                <TestimonialCard
                  quote={item.acf?.patient_review}
                  name={item.acf?.patient_name}
                  title={item.acf?.treatment_related_}
                  image={item.acf?.image || "/placeholder.svg"}
                  rating={item.acf?.patient_rating || 5}
                />
              </CarouselItem>
            ))}
          </CarouselContent>

          <div className="flex justify-center mt-8">
            <CarouselPrevious className="relative mr-2 left-0" />
            <CarouselNext className="relative ml-2 right-0" />
          </div>
        </Carousel>

        <div className="flex justify-center mt-8">
          <Button
            variant="outline"
            className="gap-2 border-primary text-primary hover:bg-primary hover:text-white"
            asChild
          >
            <Link to="/testimonials">
              View All Testimonials
              <ChevronRight className="w-4 h-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  )
}
